import React from "react";
import AbstractPage from "./AbstractPage";

class CommunityEngagementCard extends AbstractPage {
  constructor(props) {
    super(props)

    this.title = "Community Engagement Card";
  }

  render() {
    return ""
  }
}

export default CommunityEngagementCard;



// WEBPACK FOOTER //
// ./src/views/CommunityEngagementCard.js